// @flow
import { AddressControl } from "./address-control";

export default AddressControl;